module.exports = __webpack_public_path__ + "static/jung-a29336dfa6e3dfed2e2f01758707815b.jpg";